const Language = ({ language }) => {
  return (
    <UI.Text>{ language }</UI.Text>
  )
}

Language.displayName = 'Build.Language'

export default Language;
